import React, { useEffect, useState, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import "./App.css";
import { Home } from './components/Pages/Home';
import { About } from './components/Pages/About';
import { Contact } from './components/Pages/Contact';
import { ErrorPage } from './components/Pages/ErrorPage';
import { Minecraft } from './components/Pages/Minecraft';
import { Unturned } from './components/Pages/Unturned';
import { Factorio } from './components/Pages/Factorio';
import { Services } from './components/Pages/Services';
import { TOS } from './components/Pages/TOS';
import { PrivacyPolicy } from './components/Pages/PrivacyPolicy';
import { AcceptableUse } from './components/Pages/AcceptableUse';
import { RefundPolicy } from './components/Pages/RefundPolicy';
import { VPS } from './components/Pages/VPS';
import { Hardware } from './components/Pages/Hardware';
import { Zomboid } from './components/Pages/Zomboid';
import { Partner } from './components/Pages/Partner';
import { Affiliates } from './components/Pages/Affiliates';

function App() {
  const vpsEnabled = false;
  const promoBannerStorageKey = 'promo-banner-dismissed-v1';
  const [showPromoBanner, setShowPromoBanner] = useState(true);

  useEffect(() => {
    // Tell prerenderer + Discord bots that React has finished rendering
    window.__PRERENDER_READY__ = true;

    const isDismissed = localStorage.getItem(promoBannerStorageKey) === 'true';
    if (isDismissed) {
      setShowPromoBanner(false);
    }
  }, []);

  const dismissPromoBanner = () => {
    localStorage.setItem(promoBannerStorageKey, 'true');
    setShowPromoBanner(false);
  };

  return (
    <Router>
      <div className="app-shell">
        <NavBar />
        <div className="app-content">
          {showPromoBanner && (
            <div className="promo-banner" role="status" aria-live="polite">
              <p className="promo-banner__text">
                New users get <strong>50% off for 1 month</strong> with code <strong>WELCOME50</strong> at checkout.
                <span className="promo-banner__note">One-time use per account.</span>
              </p>
              <button
                type="button"
                className="promo-banner__dismiss"
                onClick={dismissPromoBanner}
                aria-label="Dismiss discount banner"
              >
                ✕
              </button>
            </div>
          )}
          <Routes>
            <Route path="/" element={<Home />} />
           {/* <Route path="/about" element={<About />} />*/}
            <Route path="/contact" element={<Contact />} />
            <Route path="/minecraft" element={<Minecraft />} />
            <Route path="/unturned" element={<Unturned />} />
            <Route path="/services" element={<Services />} />
            <Route path="/hardware" element={<Hardware />} />
            {/*<Route path="/factorio" element={<Factorio />} /> */}
            <Route path="/tos" element={<TOS />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/acceptable-use" element={<AcceptableUse />} />
            <Route path="/refunds" element={<RefundPolicy />} />
           {/*  <Route path="/zomboid" element={<Zomboid />} /> */}
            <Route path="/partnerships" element={<Partner />} />
            <Route path="/affiliates" element={<Affiliates />} />
            {vpsEnabled && <Route path="/vps" element={<VPS />} />}
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}
export default App;
